<template>
    <div>
        <div class="offerSectionContainer">
            <h1>Nos offres</h1>
            <h2>Créateur de convivialité, source de productivité.</h2>
            <div class="top">
                <div class="values">
                    <div v-for="index in 4" :key="index" :class="`grid-${index} element`"
                         :style="`background-image: url('/images/picto-${index}.svg')`"
                    >
                    </div>
                </div>
                <div class="offer-separator"></div>
                <div class="text">
                    <p>Notre mission, <span>réenchanter la vie dans vos bureaux</span>, partout en Europe !
                        <br>
                        Nous vous accompagnons avec une <span>offre saine et engagée</span>, en libre-service, pour
                        permettre à vos collaborateurs de faire le plein de vitamines et de partager de bons moments.
                    </p>
                    <br>
                    <p>Créez un environnement de travail propice au bien-être et à la créativité ! Engagez et fidélisez
                        vos salariés grâce à un snack program de qualité, flexible, qui répond à vos besoins et à leurs
                        envies.
                        <span>Découvrez ici l’ensemble de nos offres, et n’hésitez pas à faire évoluer la vôtre pour
                            répondre au mieux à vos enjeux.</span>
                    </p>
                    <br>
                    <p>Cerise sur le gâteau ! <span>Nous avons rejoint le mouvement B Corp.</span>
                        <br>
                        Cette certification est une vraie reconnaissance de nos engagements sociaux, sociétaux et
                        environnementaux, depuis le début. Des engagements intégrés dans notre mission, notre modèle
                        économique, notre gestion en interne, nos produits et notre service.
                        <br>
                        Pour en savoir plus sur nos engagements, <a href="/rse/rse.pdf" download
                                                                    title="Télécharger notre charte RSE">téléchargez
                            notre charte RSE !</a>
                    </p>
                </div>
            </div>
            <div class="offerContainer">
                <div :class="`offer offer-${key}`" v-for="(document, key) in offersDocuments" :key="document.id">
                    <a :href="getOfferLink(document)" :title="document.name" target="_blank">
                        <img :src="document.iconURL" :alt="document.name">
                        <div>
                            <p>{{ document.name }}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="go-to-chat">
            <button :disabled="this.disabled" @click="allOffers">
                Vous souhaitez en savoir plus sur une offre ? Rendez-vous sur le chat !
            </button>
        </div>
    </div>
</template>

<script>
import {apiCallRebuild, notifyErrorFetchRaw, notifyOk} from "@/helper";
import {api, API_ROUTES} from "@/Services/api.common.service";
import {
    CTA_MESSAGE_RETURN,
    HARDCODED_LINKS_OFFERS,
    OFFERS_CATEGORY_ID
} from "@/setup.const";
import "./offerModal.scss";

export default {
    data() {
        return {
            disabled: false,
            offersDocuments: {},
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        async allOffers() {
            this.disabled = true;
            this.currentOffert = "toute les offres";
            await this.ask();
        },
        async ask() {
            const notify = notifyOk.bind(this);
            const notifyError = notifyErrorFetchRaw.bind(this);

            try {
                await api().post("offers/interested", {
                    department: "cx",
                    offer: this.currentOffert,
                });

                notify(CTA_MESSAGE_RETURN);
            } catch (e) {
                notifyError();
            }
        },
        async fetchData() {
            const notifyError = notifyErrorFetchRaw.bind(this);

            try {
                const resApi = await apiCallRebuild(API_ROUTES.communication);
                const documents = resApi?.documents?.documents || [];

                this.offersDocuments = documents.filter(document => {
                    return document.visible && OFFERS_CATEGORY_ID === document.adminCategory
                });

                this.loading = false;
            } catch (e) {
                console.error(e);
                notifyError();
            }
        },
        getOfferLink(document) {
            const link = HARDCODED_LINKS_OFFERS.find(doc => doc.name === document.name);

            return link ? link.url : document.documentURL;
        },
    },
};
</script>

<style lang="scss" scoped>
.top {
    display: flex;
    align-items: center;

    .text {
        flex: 5;
        margin-right: 50px;

        p, span, a {
            font-size: 11px;
        }

        span {
            font-weight: 700;
        }

        a {
            font-weight: bold;
            text-decoration: underline;
        }
    }

    .offer-separator {
        width: 110px;
    }

    .values {
        flex: 4;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-column-gap: 0;
        grid-row-gap: 0;

        .element {
            min-height: 130px;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
}

.offerSectionContainer {
    h1 {
        font-size: 3.5em;
        margin-bottom: 40px;
    }

    h2 {
        font-size: 1.7em;
        color: var(--main-red);
        margin-bottom: 20px;
    }
}

.noFirst {
    margin-left: 0 !important;
}

.offerContainer {
    margin-top: min(4vw, 70px);
    display: flex;
    column-gap: min(8vw, 150px);
    padding: 0 70px;

    .offer {
        cursor: pointer;
        flex: 1;

        &.offer-0 div {
            background: var(--main-red);
        }

        &.offer-1 div {
            background: var(--main-yellow);
        }

        &.offer-2 div {
            background: var(--main-green);
        }

        &.offer-3 div {
            background: var(--main-purple);
        }

        img {
            width: 100%;
            aspect-ratio: 1.5;
            object-fit: cover;
            margin-bottom: 1rem;
        }

        div {
            padding: 0.3em 0;

            p {
                color: white;
                font-size: 0.9em;
                font-family: Ultramagnetic, sans-serif;
                text-align: center;
            }
        }
    }
}

.go-to-chat {
    text-align: center;
    margin-top: 1rem;

    button {
        font-family: Ultramagnetic, sans-serif;
        font-size: 1.2em;
        font-weight: bold;
        text-decoration: underline;
        margin-top: 1.6em;
    }
}

@media screen and (max-width: 1280px) {
    .values {
        .element {
            background-size: 100%;
        }
    }

    .top .text {
        p, span, a {
            font-size: 11px;
        }
    }
}

@media screen and (min-width: 1400px) {
    .top .text {
        p, span, a {
            font-size: 12px;
        }
    }
}
</style>
